<script>
import { getTemplates, deleteTemplate } from '@/utils/whatsapp-followup-template'
import WhatsappFollowupTemplateModal from '@/components/modal/whatsapp-followup-template-modal.vue'

export default {

    components: {
        WhatsappFollowupTemplateModal
    },

    inject: ['setLoading'],

    data() {
        return {
            title: "Settings",
            text: "Administration",
            data: []
        }
    },

    mounted() {
        this.templates()
    },

    methods: {

        async templates() {

            this.setLoading(true)

            try {

                const response = await getTemplates()

                this.data = response?.data?.data?.data || []

            } catch (error) {

                this.$swalToast(error.message, 'error')

            } finally {

                this.setLoading(false)

            }

        },

        // SweetAlert confirm delete
        confirmDelete(id) {

            this.$swal({
                title: "Confirm Delete",
                text: "You want to delete this template!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes Delete",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6"
            }).then((result) => {

                if (result.isConfirmed) {
                    this.removeTemplate(id)
                }

            })

        },

        // Delete API
        async removeTemplate(id) {

            this.setLoading(true)

            try {

                const response = await deleteTemplate(id)

                this.$swalToast(response.data.message)

                this.templates()

            } catch (error) {

                this.$swalToast(error.message, 'error')

            } finally {

                this.setLoading(false)

            }

        }

    }

}
</script>


<template>

    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">

        <div class="content">

            <!-- Breadcrumb -->
            <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                <breadcrumb :title="title" :text="text" text1="WhatsApp Followup Templates" />
            </div>

            <!-- Settings Tabs -->
            <settings-tab></settings-tab>

            <div class="row">

                <!-- LEFT SIDEBAR -->
                <others-sidebar></others-sidebar>

                <!-- RIGHT CONTENT -->
                <div class="col-xl-9">

                    <div class="card">

                        <div class="card-header d-flex justify-content-between">

                            <h5>WhatsApp Followup Templates</h5>

                            <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#template_modal"
                                @click="$refs.templateModal.template()">

                                <i class="ti ti-circle-plus me-2"></i>
                                Add Template

                            </button>

                        </div>

                        <div class="card-body card-table-wrapper">

                            <div class="table-responsive">

                                <table class="card-table">

                                    <thead>

                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Code</th>
                                            <th>Message</th>
                                            <th>Action</th>
                                        </tr>

                                    </thead>

                                    <tbody>

                                        <tr v-for="(row, index) in data" :key="row.id">

                                            <td>{{ index + 1 }}</td>

                                            <td>{{ row.name }}</td>

                                            <td>{{ row.code }}</td>

                                            <td>
                                                After {{ row.trigger_after }} Days
                                            </td>

                                            <td>

                                                <div class="dropdown">

                                                    <button class="btn btn-icon btn-sm rounded-circle"
                                                        data-bs-toggle="dropdown">

                                                        <i class="ti ti-dots-vertical"></i>

                                                    </button>

                                                    <ul class="dropdown-menu dropdown-menu-end">

                                                        <li>

                                                            <a class="dropdown-item" data-bs-toggle="modal"
                                                                data-bs-target="#template_modal"
                                                                @click="$refs.templateModal.template(row)">

                                                                <i class="ti ti-edit me-2"></i>
                                                                Edit

                                                            </a>

                                                        </li>

                                                        <li>

                                                            <a class="dropdown-item text-danger"
                                                                href="javascript:void(0)"
                                                                @click="confirmDelete(row.id)">

                                                                <i class="ti ti-trash me-2"></i>
                                                                Delete

                                                            </a>

                                                        </li>

                                                    </ul>

                                                </div>

                                            </td>

                                        </tr>

                                        <tr v-if="!data.length">

                                            <td colspan="5" class="text-center text-muted p-3">
                                                No templates found
                                            </td>

                                        </tr>

                                    </tbody>

                                </table>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

        <app-footer></app-footer>

    </div>

    <!-- Modal -->
    <whatsapp-followup-template-modal ref="templateModal" @updated="templates" />

</template>